/**
 * Raffle Layout Component
 * Wraps raffle pages with the theme provider and common elements
 */

import { ReactNode } from 'react';
import { RaffleThemeProvider } from '@/contexts/RaffleThemeContext';
import { ThemeToggle, Snowflakes } from './ThemeToggle';

interface RaffleLayoutProps {
  children: ReactNode;
}

export function RaffleLayout({ children }: RaffleLayoutProps) {
  return (
    <RaffleThemeProvider>
      <ThemeToggle />
      <Snowflakes />
      {children}
    </RaffleThemeProvider>
  );
}

/**
 * HOC to wrap a component with RaffleLayout
 */
export function withRaffleTheme<P extends object>(
  WrappedComponent: React.ComponentType<P>
) {
  return function WithRaffleTheme(props: P) {
    return (
      <RaffleLayout>
        <WrappedComponent {...props} />
      </RaffleLayout>
    );
  };
}
